import charts from '../charts.js';

export default function({ id, data, config, dates }) {
	const settings = {
		data,
		dataFormatter(data) {
			return data.map(row => {
				row.settings = {
					fill:	row.gain_loss >= 0 ? charts.colours.green : charts.colours.red,
					stroke:	row.gain_loss >= 0 ? charts.colours.green : charts.colours.red,
				};

				return row;
			});
		},
		scrollbar: false,
		legend: {
			labels: {
				maxWidth: null,
			},
		},
		xAxis: {
			baseInterval: {
				timeUnit: 'year',
				count: 1,
			},
		},
		yAxis: {
			numberFormat: "#'%'",
		},
	};

	const chart = charts.draw(id, settings, dates);

	chart.addSeries(
		chart.columnSeries({
			name: 'annual',
			valueYField: 'gain_loss',
			fill: charts.colours.green,
			stroke: charts.colours.green,
			legendLabelText: 'Share Price Annual Return',
			templateField: 'settings',
		})
	);

	return chart;
}
